import { render, staticRenderFns } from "./Tokens.vue?vue&type=template&id=a8e7f724&scoped=true"
import script from "./Tokens.vue?vue&type=script&lang=js"
export * from "./Tokens.vue?vue&type=script&lang=js"
import style0 from "./Tokens.vue?vue&type=style&index=0&id=a8e7f724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e7f724",
  null
  
)

export default component.exports